import { render, staticRenderFns } from "./Trashbin.vue?vue&type=template&id=7cd8fdf0&scoped=true&"
import script from "./Trashbin.vue?vue&type=script&lang=js&"
export * from "./Trashbin.vue?vue&type=script&lang=js&"
import style0 from "./Trashbin.vue?vue&type=style&index=0&id=7cd8fdf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd8fdf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.STrKMrcDoQYq/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd8fdf0')) {
      api.createRecord('7cd8fdf0', component.options)
    } else {
      api.reload('7cd8fdf0', component.options)
    }
    module.hot.accept("./Trashbin.vue?vue&type=template&id=7cd8fdf0&scoped=true&", function () {
      api.rerender('7cd8fdf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList/Trashbin.vue"
export default component.exports